// extracted by mini-css-extract-plugin
export var card = "_6f-0";
export var failedIcon = "_6f-4";
export var failedIconBadge = "_6f-3";
export var icon = "_6f-1";
export var successIcon = "_6f-2";